<template>
    <Widget 
        :title="$t('components.ExistingVsNewOnes.Title')" 
        :info="$t('widgetsInfo.ExistingVsNewOnes')"
        :loading="loading"
        :report-mode="reportMode"
        v-resize="onResize">
        <DoughnutChart 
            :stats="stats" 
            :colors="colors"
            :mobile="mobile"
            :styles="styles" 
            :showTotal="false"
            :showLabels="true"
            unit="%" />
    </Widget>
</template>

<script>
/** 
 * ExistingVsNewOnes wraps a DoughnutChart and contains the functions to 
 * parse data from the API.
 * 
 * It represents the number of chat interactions grouped by devices. It also
 * display the total number of interactions from any device in the middle of
 * the chart.
 */

import Widget from '@/components/dashboard/Widget';

import DoughnutChart from '@/components/dashboard/charts/DoughnutChart';

export default {
    name: 'ExistingVsNewOnes',
    data: () => ({ 
        stats: {},
        colors: [],
        mobile: false,
        styles: {
            position: 'relative',
            width: '100%'
        },
        legend: {}
    }),
    props: {
        loading: {
            type: Boolean,
            default: true
        },
        chatsData: {
            type: Object,
            required: true,
        },
        reportMode: {
            type: String,
            default: null
        }
    },
    created() {
        const colors = this.$vuetify.theme.isDark ? 
            this.$vuetify.theme.themes.dark : this.$vuetify.theme.themes.light;
        
        this.colors = [
            colors.ddblue,
            colors.ddgreen
        ]
    },
    mounted() {
        this.updateStats(this.chatsData);
    },
    watch: {
        chatsData(newData) {
            this.updateStats(newData);
        }
    },
    methods: {
        updateStats(data) {
            if (data) {
                const $t = this.$t.bind(this);

                const labels = Object.keys(data).map(label => $t(`components.ExistingVsNewOnes.${label}Label`));
                this.stats = {
                    labels,
                    datasets: [{
                        data: Object.values(data).filter(val => Number(val) !== 0), 
                        backgroundColor: this.colors,
                        borderWidth: 0
                    }]
                };
            }
        },
        onResize() {
            this.mobile = window.innerWidth < 600;
        }
    },
    components: { Widget, DoughnutChart }
}
</script>
